export default [
  {
    id: 'violet',
    color: '#891BE8',
  },
  {
    id: 'darkBlue',
    color: '#4339F2',
  },
  {
    id: 'blue',
    color: '#0AAAF4',
  },
  {
    id: 'green',
    color: '#1AD698',
  },
  {
    id: 'yellow',
    color: '#F8BD1C',
  },
  {
    id: 'red',
    color: '#E33233',
  },
];
